import { useEffect } from "react";
import { getUserDetails } from "../utils/getUserDetails";
 
export default function ClarityIdentify() {
  const userDetails = getUserDetails();
  const recruiterId = userDetails?.recruiter_id;
console.log()
  useEffect(() => {
    if (!recruiterId) return;
 
    const interval = setInterval(() => {
      if (typeof window !== "undefined" && window.clarity) {
        window.clarity?.("identify", recruiterId);
        clearInterval(interval);
      }
    }, 300);
 
    return () => clearInterval(interval);
  }, [recruiterId]);
 
  return null;
}
